import {Injectable} from "@angular/core";
import {PageOrientation, PdfExportProperties} from "@syncfusion/ej2-angular-grids";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

@Injectable()
export class ReportsUtil {
  constructor() {
  }

  PDFHeader(params: {
    arquivo: string,
    titulo: string,
    data: string,
    periodo: string,
    conteudo: object,
    extraHeight?: number,
    empresa?: string,
    dataSource?: any,
    filhos?: boolean,
    orientacao: PageOrientation
  }): PdfExportProperties {
    let contents: any = [
      {
        type: 'Text',
        value: `${params.titulo}`,
        position: {x: 1, y: 1},
        style: {textBrushColor: '#000000', fontSize: 18, hAlign: 'Center'}
      },
      {
        type: 'Text',
        value: !params.empresa ? localStorage.getItem('empresa') : params.empresa,
        position: {x: 300, y: 1},
        style: {textBrushColor: '#343a40', fontSize: 15, hAlign: 'Center'}
      },
      {
        type: 'Text',
        value: `${params.data}`,
        position: {x: 600, y: 1},
        style: {textBrushColor: '#343a40', fontSize: 10}
      },
      {
        type: 'Text',
        value: `${params.periodo}`,
        position: {x: 1, y: 30},
        style: {textBrushColor: '#000000', fontSize: 12, hAlign: 'Center'}
      }
    ];


    let x = 1;
    let y = 60;
    for (let key in params.conteudo) {
      if (params.conteudo.hasOwnProperty(key)) {
        if (key == 'Imóveis') {
          contents.push({
              type: 'Text',
              value: `${key}:`,
              position: {x: 300, y: 60},
              style: {textBrushColor: '#343a40', fontSize: 10, hAlign: 'Center'}
            },
            {
              type: 'Text',
              value: `${params.conteudo[key]}`,
              position: {x: 380, y: 60},
              style: {textBrushColor: '#000000', fontSize: 10}
            }
          );
        } else {
          contents.push({
              type: 'Text',
              value: `${key}:`,
              position: {x: x, y: y},
              style: {textBrushColor: '#343a40', fontSize: 10, hAlign: 'Center'}
            },
            {
              type: 'Text',
              value: `${params.conteudo[key]}`,
              position: {x: x + 80, y: y},
              style: {textBrushColor: '#000000', fontSize: 10}
            }
          );
          y += 30;
        }
      }
    }

    y += params.extraHeight ? params.extraHeight : 0;

    contents.push({
      type: 'Line',
      style: {penColor: '#6c757d', penSize: 1, dashStyle: 'Solid'},
      points: {x1: 0, y1: y, x2: 685, y2: y}
    });

    y += 10;

    return {
      fileName: `${params.arquivo}.pdf`,
      pageOrientation: params.orientacao,
      allowHorizontalOverflow: false,
      dataSource: params.dataSource,
      hierarchyExportMode: params.filhos ? 'All' : 'None',
      header: {
        fromTop: 0,
        height: y,
        contents: contents
      },
      footer: {
        fromBottom: 1,
        height: 15,
        contents: [
          {
            type: 'PageNumber',
            position: {x: 1000, y: 1},
            style: {textBrushColor: '#343a40', fontSize: 10, hAlign: 'Right'}
          }
        ]
      },
      theme: {
        header: {
          fontColor: '#000000', fontName: 'Calibri', fontSize: 6, bold: true,
          border: {color: '#FFFFFF', lineStyle: 'Thin'}
        },
        record: {
          border: {color: '#FFFFFF', lineStyle: 'Thin'},
          fontColor: '#000000', fontName: 'Calibri', fontSize: 6, bold: false
        },
        caption: {
          fontColor: '#000000', fontName: 'Calibri', fontSize: 6, bold: true,
          border: {color: '#FFFFFF', lineStyle: 'Thin'}
        }
      },
    };
  }

  /*

  * exportPDF
  cria um arquivo PDF com os parametros passados

  PARAMETROS

    doc: {
      arquivo: nome do arquivo
      orientacao: 'Portrait' ou 'Landscape'
    };
    cabecalho: {
      titulo: titulo grandão
      data: data de emissão
      periodo: periodo de emissão
      parametros: parametros do relatório
      image: imagem no cabeçalho?
      empresa?: (opcional) nome da empresa ou um subtitulo
      alturaExtra?: (opcional) altura extra para os parametros
    };
    tabela: {
      dados: dados da tabela
      colunas: colunas da tabela {header: string, dataKey: string}
      diminuir?: (opcional) diminuir o tamanho da fonte e das margens
      hierarquico?: (opcional) tabela que possui sublinhas que possui formatação especial
      quebraTabela?: (opcional) quebra a tabela em duas
      repeteColuna?: (opcional) coluna que será repetida na segunda tabela
      estiloColunas?: (opcional) estilo das colunas {dataKey: string, estiloEspecificoBaseadoNaDocumentacao: string}
      cabecalhoEscondido?: (opcional) esconde o cabeçalho da tabela e quando hierarquico, deixa a primeira linha como cabeçalho
    };

  DOCUMENTAÇÃO:
    https://artskydj.github.io/jsPDF/docs/jsPDF.html
    https://github.com/simonbengtsson/jsPDF-AutoTable
    https://phppot.com/javascript/jspdf-autotable/
  */
  exportPDF(params: {
    doc: {
      arquivo: string;
      orientacao: string;
    };
    cabecalho: {
      titulo: string;
      data: string;
      periodo: string;
      parametros: object;
      image: boolean;
      empresa?: string;
      alturaExtra?: boolean;
      dividido?: boolean;
    };
    tabela: {
      dados: any[];
      colunas: any[];
      footer?: any[];
      diminuir?: boolean;
      hierarquico?: boolean;
      quebraTabela?: boolean;
      repeteColuna?: any;
      estiloColunas?: any[];
      cabecalhoEscondido?: boolean;
      chartImages?: string;
    };
  })
  {
    const doc = new jsPDF({
      orientation: params.doc.orientacao,
      unit: 'cm',
      format: 'a4'
    });

    let cordinates = {
      x: 2,
      y: 2,
      width: 27.7,
      height: 19
    };
    // 29,7 x 21 -> 2cm de margem dos dois lados
    if (params.doc.orientacao == 'Portrait') {
      cordinates = {
        x: 2,
        y: 2,
        width: 19,
        height: 27.7
      }
    }

    let y = this.setHeader(doc, params, cordinates);

    if (params.tabela.chartImages === 'one_img'){
      doc.addImage(localStorage.getItem('cons'), 'png', 1, 3.6, 28, 6.5);
      localStorage.removeItem('cons');
    }

    if (params.tabela.chartImages === 'two_img_double_pie_bar') {
      doc.addImage(localStorage.getItem('bar'), 'png', 3, 6.5, 23.8, 8);
      localStorage.removeItem('bar');
      doc.addPage('a4', params.doc.orientacao);
      doc.addImage(localStorage.getItem('pie'), 'png', 3.5, 6.5, 23.8, 8.6);
      localStorage.removeItem('pie');
      this.setHeader(doc, params, cordinates);
    }

    if (params.tabela.chartImages === 'two_img_double_pie') {
      doc.addImage(localStorage.getItem('bar'), 'png', 2.5, 7.3, 13, 7.7);
      localStorage.removeItem('bar');
      doc.addImage(localStorage.getItem('pie'), 'png', 14.9, 7.3, 13.5, 8);
      localStorage.removeItem('pie');
    }


    if (params.tabela.chartImages === 'two_img_double_bar') {
      doc.addImage(localStorage.getItem('bar'), 'png', 3.2, 7.0, 23.8, 8);
      localStorage.removeItem('bar');
      doc.addPage('a4', params.doc.orientacao);
      doc.addImage(localStorage.getItem('pie'), 'png', 3.2, 7.0, 23.8, 8);
      localStorage.removeItem('pie');
      this.setHeader(doc, params, cordinates);
    }

    if (params.tabela.chartImages === 'gerencial'){
      doc.addImage(localStorage.getItem('bar'), 'png', 2.3, 6.0, 23.8, 10);
      localStorage.removeItem('bar');
      doc.addPage('a4', params.doc.orientacao);
      doc.addImage(localStorage.getItem('pie'), 'png', 4.5, 6.2, 23.8, 11);
      localStorage.removeItem('pie');
      this.setHeader(doc, params, cordinates);
    }


    let estiloColunas = {};
    if (params.tabela.estiloColunas) {
      params.tabela.estiloColunas.forEach((coluna, index) => {
        estiloColunas[coluna.dataKey] = coluna;
      })
    }

    let colunas = params.tabela.colunas;
    let auxColunas = [];
    if (params.tabela.quebraTabela) {
      colunas = colunas.slice(0, (colunas.length / 2));
      auxColunas = params.tabela.colunas.slice(colunas.length, params.tabela.colunas.length);
      auxColunas.unshift(params.tabela.repeteColuna)
    }

    let fillColor = params.tabela.hierarquico ? "#f5f5f5" : "#e8e6e6";
    let paramsTable = {
      columns: colunas,
      body: params.tabela.dados,
      foot: params.tabela.footer,
      theme: 'striped',
      // margin: {left: 2, right: 2, bottom: 2},
      margin: {left: params.tabela.diminuir ? 1 : 2, right: params.tabela.diminuir ? 1 : 2, bottom: 2},
      startY: y + 0.5,
      styles: {
        fontSize: params.tabela.diminuir ? 5 : 9,
      },
      headStyles: {
        fillColor: "#009C57",
        textColor: "#FFF"
      },
      footStyles: {
        fillColor: "#d3d3d3",
        textColor: "#000000",
        halign: 'center'
      },
      showHead: !params.tabela.cabecalhoEscondido,
      showFoot: params.tabela.footer ? 'lastPage' : 'never',
      alternateRowStyles: {
        fillColor: fillColor,
      },
      columnStyles: estiloColunas,
      didParseCell: function (data) {
        if (data.row.raw.children && params.tabela.hierarquico) {
          data.cell.styles.fillColor = [232, 230, 230];
          if (params.tabela.cabecalhoEscondido) {
            data.cell.styles.fillColor = [0, 156, 87];
          }
        }
      },
      willDrawCell: function (data) { // Called before a cell or row is drawn
        // console.log(data)
        if (data.cell.raw != null && data.section == 'body') {
          if (typeof data.cell.raw == "string" && data.column.dataKey != "outlay" && data.column.dataKey != "incoming" && data.column.dataKey != "valorTotal"
            && data.column.dataKey != "despesa" && data.column.dataKey != "receita" && (data.row.raw.children || !params.tabela.hierarquico)) {
            if (data.cell.raw.includes('R$') && data.column.dataKey != "ano1" && data.column.dataKey != "ano2" && data.column.dataKey != "absoluto") {
              if (data.cell.raw.includes('-')) {
                doc.setTextColor(194, 37, 37);
              } else if (data.cell.raw.includes(' 0,00')) {
                doc.setTextColor(20);
              } else {
                doc.setTextColor(0, 156, 86);
              }
            } else {
              doc.setTextColor(20);
            }
          } else if (typeof data.cell.raw == "number" && data.column.dataKey == "finalBalance") {
            if (data.cell.raw < 0) {
              doc.setTextColor(194, 37, 37);
            } else if (data.cell.raw > 0) {
              doc.setTextColor(0, 156, 86);
            }
          }
          if (data.row.raw.conta && (data.row.raw.conta === 'SALDO' || data.row.raw.conta === 'SALDO ACUMULADO')) {
            doc.setFontStyle("bold");
          }

          if (data.row.raw.children && params.tabela.hierarquico) {
            doc.setFontStyle("bold");
            if (data.row.raw.accountDescription && data.column.index == 0) {
              data.cell.text = "Conta: " + data.row.raw.accountDescription;
              data.cell.styles.overflow = 'visible';
              data.cell.width = data.table.width
              data.row.cells = data.cell;
            }

            if (data.column.index == 0 && data.row.raw.month) {
              data.cell.text = "    " + data.row.raw.month;
              data.cell.styles.overflow = 'visible';
              data.cell.width = data.table.width
              data.row.cells = data.cell;
            }
            if (params.tabela.cabecalhoEscondido) {
              doc.setTextColor(255, 255, 255);
            }
          }
        }
      }
    };
    doc.autoTable(paramsTable);

    if (params.tabela.quebraTabela) {
      paramsTable.columns = auxColunas;
      paramsTable.startY = doc.autoTable.previous.finalY + 1;
      doc.autoTable(paramsTable);
    }

    const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(8)
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.addImage(farmcont, 'png', ((cordinates.width + 2) / 2), cordinates.height, 0.5, 0.5, {align: 'center'})
      doc.text(String(i), cordinates.width, cordinates.height, {
        align: 'right'
      })
    }

    doc.save(params.doc.arquivo + '.pdf');
  }

  exportPDFGraph(params: {
    doc: {
      arquivo: string;
      orientacao: string;
    };
    cabecalho: {
      titulo: string;
      data: string;
      periodo: string;
      parametros: object;
      image: boolean;
      empresa?: string;
      alturaExtra?: boolean;

    };
    graficos: Array<{
      titulo: string;
      imagem: string;
      altura: number;
      largura: number;
      meiaPagina: boolean;
    }>;
  }) {
    const doc = new jsPDF({
      orientation: params.doc.orientacao,
      unit: 'cm',
      format: 'a4'
    });

    let cordinates = {
      x: 2,
      y: 2,
      width: 27.7,
      height: 19
    };
    // 29,7 x 21 -> 2cm de margem dos dois lados
    if (params.doc.orientacao == 'Portrait') {
      cordinates = {
        x: 2,
        y: 2,
        width: 19,
        height: 27.7
      }
    }

    if (params.cabecalho.image) {
      let image = localStorage.getItem('userPicture');
      if (!image.includes('.png')) image = image.slice(image.indexOf(',') + 1);
      else image = farmcont;
      doc.addImage(image, 'png', 2, 1, 3, 3)
      cordinates.x += 3.5;
      cordinates.y += 3.5;
    }

    doc.setFontStyle("bold");
    doc.setFontSize(15);
    doc.text(`${params.cabecalho.titulo}`, cordinates.x, 2);

    doc.setFontStyle("normal");
    doc.setFontSize(13);
    let empresa = params.cabecalho.empresa ? params.cabecalho.empresa : localStorage.getItem('empresa');
    doc.text(empresa, ((cordinates.width + 2) / 2), 2, {align: 'center'});

    doc.setFontSize(11);
    doc.setFontStyle("normal");
    doc.text(`${params.cabecalho.periodo}`, cordinates.width, 2, {align: 'right'});
    doc.setFontStyle("italic");
    doc.setFontSize(10);
    doc.text(`${params.cabecalho.data}`, cordinates.width, 2.5, {align: 'right'});


    doc.setFontSize(8);
    let x = cordinates.x;
    let y = 2.7;
    for (let key in params.cabecalho.parametros) {
      if (params.cabecalho.parametros.hasOwnProperty(key)) {
        if (key == 'Imóveis') {
          doc.setFontStyle("italic");
          doc.text(`${key}:`, (cordinates.width / 2) + 1, 2.7);
          doc.setFontStyle("normal");
          doc.text(`${params.cabecalho.parametros[key]}`, (cordinates.width / 2) + 2.5, 2.7);
        } else {
          doc.setFontStyle("italic");
          doc.text(`${key}:`, x, y);
          doc.setFontStyle("normal");
          doc.text(`${params.cabecalho.parametros[key]}`, (params.cabecalho.alturaExtra != undefined ? x + 3 : x + 2), y, {maxWidth: cordinates.width - (x + 4)});
          y += 0.5;
          y += this.incrementYBasedOnStringLength(params.cabecalho.parametros[key]);
        }
      }
    }
    if (params.cabecalho.alturaExtra) {
      y += 0.5;
    }

    doc.setLineWidth(0.05);
    doc.line(2, y, cordinates.width, y);

    params.graficos.forEach((grafico, i, index) => {
      let img = grafico.imagem.slice(grafico.imagem.indexOf(',') + 1)
      let x = cordinates.x;
      let y2 = y + 1;
      if (grafico.titulo) {
        doc.text(grafico.titulo, cordinates.width / 2, y2, {align: 'center'});
        y2 += 1;
      }
      doc.addImage(img, 'png', x, y2, grafico.largura / 50, grafico.altura / 50);
      y += (grafico.altura / 50) + 1;
      if (i % 2 !== 0 && i != index.length - 1) {
        doc.addPage('a4', params.doc.orientacao)
        y = cordinates.y;
      }
    });

    const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(8)
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.addImage(farmcont, 'png', ((cordinates.width + 2) / 2), cordinates.height, 0.5, 0.5, {align: 'center'});
      doc.text(String(i), cordinates.width, cordinates.height, {
        align: 'right'
      });
    }

    doc.save(params.doc.arquivo + '.pdf');
  }

  exportPDFGrid(params: {
    doc: {
      arquivo: string;
      orientacao: string;
    };
    cabecalho: {
      titulo: string;
      data: string;
      periodo: string;
      parametros: object;
      image: boolean;
      empresa?: string;
      alturaExtra?: boolean;
    };
    dados: Array<{
      titulo: string;
      subtitulo: string;
      valores: object;
      meiaPagina: boolean;
      melhor: boolean;
    }>;
  }) {
    const doc = new jsPDF({
      orientation: params.doc.orientacao,
      unit: 'cm',
      format: 'a4'
    });

    let cordinates = {
      x: 1.5,
      y: 2,
      width: 28.2,
      height: 19
    };
    // 29,7 x 21 -> 2cm de margem dos dois lados
    // if (params.doc.orientacao == 'Portrait') {
    //   cordinates = {
    //     x: 2,
    //     y: 2,
    //     width: 19,
    //     height: 27.7
    //   }
    // }

    if (params.cabecalho.image) {
      let image = localStorage.getItem('userPicture');
      if (!image.includes('.png')) image = image.slice(image.indexOf(',') + 1);
      else image = farmcont;
      doc.addImage(image, 'png', 1.5, 1, 2, 2)
      cordinates.x += 2.5;
      cordinates.y += 2.5;
    }

    doc.setFontStyle("bold");
    doc.setFontSize(15);
    doc.text(`${params.cabecalho.titulo}`, cordinates.x, 2);

    doc.setFontStyle("normal");
    let empresa = params.cabecalho.empresa ? params.cabecalho.empresa : localStorage.getItem('empresa');
    doc.setFontSize(11);
    doc.setFontStyle("normal");
    doc.text(empresa, cordinates.width, 2, {align: 'right'});

    doc.setFontSize(11);
    doc.setFontStyle("normal");
    // doc.text(`${params.cabecalho.periodo}`, cordinates.width, 2, {align: 'right'});
    doc.setFontStyle("italic");
    doc.setFontSize(10);
    doc.text(`${params.cabecalho.data}`, cordinates.width, 2.5, {align: 'right'});

    doc.setFontSize(8);
    let x = cordinates.x;
    let y = 2.7;
    for (let key in params.cabecalho.parametros) {
      if (params.cabecalho.parametros.hasOwnProperty(key)) {
        doc.setFontStyle("italic");
        doc.text(`${key}:`, x, y);
        doc.setFontStyle("normal");
        doc.text(`${params.cabecalho.parametros[key]}`, (params.cabecalho.alturaExtra != undefined ? x + 3 : x + 2), y, {maxWidth: cordinates.width - (x + 4)});
        y += 0.5;
        y += this.incrementYBasedOnStringLength(params.cabecalho.parametros[key]);
      }
    }
    if (params.cabecalho.alturaExtra) {
      y += 0.5;
    }

    cordinates.x = 1.5;

    doc.setLineWidth(0.05);
    doc.line(cordinates.x, y, cordinates.width, y);

    y += 0.5;

    let border = 0.3;
    let width = (cordinates.width - cordinates.x - border) / 4;
    let x1 = cordinates.x - 0.3;
    params.dados.forEach((elem, i, index) => {
      let x2 = x1;
      let y2 = y;
      let espacamento = 0.5;


      doc.setFontStyle("normal");
      doc.setFontSize(10);
      doc.setLineWidth(0.05);
      doc.setDrawColor('#7266ba');
      doc.setTextColor('#444444');
      let height = 12.26;
      if (elem.titulo == 'Livro Caixa') {
        height = 14.95;
      }
      doc.roundedRect(x2, y2, width, height, 0.2, 0.2, 'S');

      x2 += 0.5;
      y2 += 1;

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(elem.titulo, x2, y2, {align: 'left'});
      y2 += 0.9;

      doc.setFontSize(10);
      doc.setFontStyle("italic");
      doc.text(elem.subtitulo, x2, y2, {align: 'left'});

      if (elem.melhor) {
        let x3 = x2 + (width / 2) - 0.7;
        doc.setDrawColor('#7266ba');
        doc.setFillColor('#7266ba');
        doc.roundedRect(x3, y2 - 0.5, 2.9, 0.8, 0.4, 0.4, 'DF');
        doc.setTextColor('#fff200');
        doc.setFontStyle("normal");
        doc.setFont("zapfdingbats");
        doc.text("\x48", x3 + 0.3, y2);
        doc.setFontSize(7);
        doc.setFont("helvetica");
        doc.setFontStyle("normal");
        doc.setTextColor('#FFF');
        doc.text("Menor alíquota", x3 + 0.8, y2, {align: 'left'});
      }
      doc.setTextColor('#444444');

      y2 += 0.8;
      doc.setFontSize(8);

      let dados = [
        ['+', 'Receita AR', elem.valores['amountRevenue']],
        ['+', 'Receita AR a receber', elem.valores['incomingRevenue']],
      ];

      if (elem.titulo == 'Livro Caixa') {
        dados.push(
          ['-', 'Despesas AR', elem.valores['amountExpense']],
          ['-', 'Despesas AR a pagar', elem.valores['incomingExpense']],
          ['-', 'Prejuízo', elem.valores['extraExpense']],
        );
      }

      elem.titulo == 'Livro Caixa' ? dados.push(['=', 'Total tributável', elem.valores['totalTax']]) : dados.push(['=', 'Total tributável (20%)', elem.valores['totalTax']],
      )

      dados.push(
        ['+', 'Outras receitas', elem.valores['otherRevenue']],
      );

      if (elem.subtitulo == 'Dedução Legal') {
        dados.push(
          ['-', 'Outras despesas', elem.valores['otherExpense']],
        );
      } else if (elem.subtitulo == 'Simplificada') {
        dados.push(
          ['-', 'Desconto simplificado', elem.valores['maxDiscount']],
        );
      }

      dados.push(
        ['=', 'Base de cálculo', elem.valores['calcBasis']],
        ['x', 'Alíquota', `${Intl.NumberFormat('pt-BR').format(elem.valores['tableEffectiveTaxRate'])}%`],
        ['-', 'Dedução', elem.valores['deductibleTable']],
        ['', 'Alíquota efetiva', 'Valor Pago'],
        [' ', elem.valores['effectiveTaxRate'], elem.valores['taxToPay']],
      );

      doc.setLineWidth(0.05);
      doc.setDrawColor('#7266ba');

      let paramsTable = {
        body: dados,
        columnStyles: {
          0: {cellWidth: 0.5, fontStyle: 'bold', valign: 'middle'},
          1: {cellWidth: 2, valign: 'middle'},
          2: {cellWidth: width - (2 * espacamento) - 2.5, halign: 'right', valign: 'middle'}
        },
        theme: 'plain',
        margin: {left: x2, right: x2 + width - espacamento},
        startY: y2,
        styles: {
          fontSize: 8,
        },
        showHead: false,
        allSectionHooks: true,
        didParseCell: function (data: any) {
          if (data.cell.raw == '-') {
            data
            data.cell.styles.textColor = '#f05050' // text color
          } else if (data.cell.raw == '+') {
            data.cell.styles.textColor = '#27c24c' // text color
          } else if (data.cell.raw == '=') {
            data.cell.styles.textColor = '#7266ba' // text color
          } else if (data.cell.raw == 'x') {
            data.cell.styles.textColor = '#0080ff' // text color
          }

          if (data.column.index == 2 && (typeof data.cell.raw == 'number')) {
            data.cell.styles.fontStyle = 'bold';
            data.cell.text = Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(data.cell.raw);
          }

          if (data.column.index == 1 && typeof data.cell.raw == 'number') {
            data.cell.styles.fontStyle = 'bold';
            data.cell.text = data.cell.raw.toFixed(2).toString().replace('.', ',') + "%";
          }
        },
        didDrawCell: function (data) {
          if (data.column.index == 0 && (data.cell.raw == '=' || data.cell.raw == '')) {
            doc.line(x2, data.cell.y, x2 + width - (2 * espacamento), data.cell.y);
          }
        }
      };
      doc.autoTable(paramsTable);

      x1 += width + border;
    });

    doc.setTextColor('#000000');
    const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(8)
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.addImage(farmcont, 'png', ((cordinates.width + 2) / 2), cordinates.height, 0.5, 0.5, {align: 'center'});
      doc.text(String(i), cordinates.width, cordinates.height, {
        align: 'right'
      });
    }

    doc.save(params.doc.arquivo + '.pdf');
  }

  incrementYBasedOnStringLength(str: string): number {
    const length = str.length;
    const increments = Math.floor(length / 120);
    return (increments * 0.5);
  }

  setHeader(doc: any, params: any, cordinates: any){
    if (params.cabecalho.image && (params.tabela.chartImages === undefined || params.tabela.chartImages === null) ) {
      let image = localStorage.getItem('userPicture');
      if (!image.includes('.png')) image = image.slice(image.indexOf(',') + 1);
      else image = farmcont;
      doc.addImage(image, 'png', 2, 1.25, 3, 3)
      cordinates.x += 3.5;
      cordinates.y += 3.5;
    }

    if (params.cabecalho.image && (params.tabela.chartImages !== undefined) ) {
      let image = localStorage.getItem('userPicture');
      if (!image.includes('.png')) image = image.slice(image.indexOf(',') + 1);
      else image = farmcont;
      doc.addImage(image, 'png', 2, 0.5, 3, 3)
      if (doc.internal.getCurrentPageInfo().pageNumber === 1){
        cordinates.x += 3.5;
        cordinates.y += 3.5;
      }
    }

    doc.setFontStyle("bold");
    doc.setFontSize(15);
    doc.text(`${params.cabecalho.titulo}`, cordinates.x, 2);

    if (params.tabela.chartImages !== 'gerencial') {
      doc.setFontStyle("normal");
      let empresa = params.cabecalho.empresa ? params.cabecalho.empresa : localStorage.getItem('empresa');
      doc.setFontSize(10);
      doc.text(empresa, cordinates.x, 2.5, {align: 'left'});
    }
    if (params.tabela.chartImages === 'gerencial') {
      doc.setFontStyle("normal");
      let empresa = params.cabecalho.empresa ? params.cabecalho.empresa : localStorage.getItem('nameEmpresaCont');
      doc.setFontSize(10);
      doc.text(empresa, cordinates.x, 2.5, {align: 'left'});
    }

    doc.setFontSize(11);
    doc.setFontStyle("normal");
    doc.text(`${params.cabecalho.periodo}`, cordinates.width, 2, {align: 'right'});
    doc.setFontStyle("italic");
    doc.setFontSize(10);
    doc.text(`${params.cabecalho.data}`, cordinates.width, 2.5, {align: 'right'});


    doc.setFontSize(8);
    let x = cordinates.x;
    let meio = (cordinates.width / 2) + 1;
    let y = 3.1;
    for (let key in params.cabecalho.parametros) {
      if (params.cabecalho.parametros.hasOwnProperty(key)) {
        let x2 = x;
        let y2 = y;

        if (params.cabecalho.dividido){
          if (Object.keys(params.cabecalho.parametros).indexOf(key) % 2 !== 0) {
            x2 = meio;
          }
        } else if (key == 'Imóveis') {
          x2 = meio;
          y2 = 3.1;
        }

        doc.setFontStyle("italic");
        doc.text(`${key}:`, x2, y2);
        doc.setFontStyle("normal");
        doc.text(`${params.cabecalho.parametros[key]}`, (params.cabecalho.alturaExtra != undefined ? x2 + 3.5 : x2 + 2), y2, {maxWidth: cordinates.width - (x + 4)});

        if (params.cabecalho.dividido) {
          if (Object.keys(params.cabecalho.parametros).indexOf(key) % 2 !== 0) {
            y += 0.5;
            y += this.incrementYBasedOnStringLength(params.cabecalho.parametros[key]);
          }
        } else if (key != 'Imóveis') {
          y += 0.5;
          y += this.incrementYBasedOnStringLength(params.cabecalho.parametros[key]);
        }
      }
    }
    if (params.cabecalho.alturaExtra) {
      y += 0.5;
    }

    doc.setLineWidth(0.05);
    doc.line(2, y, cordinates.width, y);

    return y;
  }
}

let
  farmcont = "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";
